export const GET_ORDER_REQUEST = "GET_ORDER_REQUEST";
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";
export const GET_ORDER_FAIL = "GET_ORDER_FAIL";

export const GET_ORDER_ADMIN_REQUEST = "GET_ORDER_ADMIN_REQUEST";
export const GET_ORDER_ADMIN_SUCCESS = "GET_ORDER_ADMIN_SUCCESS";
export const GET_ORDER_ADMIN_FAIL = "GET_ORDER_ADMIN_FAIL";

export const GET_ORDER_BY_ID_REQUEST = "GET_ORDER_BY_ID_REQUEST";
export const GET_ORDER_BY_ID_SUCCESS = "GET_ORDER_BY_ID_SUCCESS";
export const GET_ORDER_BY_ID_FAIL = "GET_ORDER_BY_ID_FAIL";

export const APPROVE_ORDER_REQUEST = "APPROVE_ORDER_REQUEST";
export const APPROVE_ORDER_SUCCESS = "APPROVE_ORDER_SUCCESS";
export const APPROVE_ORDER_FAIL = "APPROVE_ORDER_FAIL";

export const MARK_PICKED_ORDER_REQUEST = "MARK_PICKED_ORDER_REQUEST";
export const MARK_PICKED_ORDER_SUCCESS = "MARK_PICKED_ORDER_SUCCESS";
export const MARK_PICKED_ORDER_FAIL = "MARK_PICKED_ORDER_FAIL";

export const ORDER_CANCEL_REQUEST = "ORDER_CANCEL_REQUEST";
export const ORDER_CANCEL_SUCCESS = "ORDER_CANCEL_SUCCESS";
export const ORDER_CANCEL_FAIL = "ORDER_CANCEL_FAIL";

export const MARK_DELIVERED_ORDER_REQUEST = "MARK_DELIVERED_ORDER_REQUEST";
export const MARK_DELIVERED_ORDER_SUCCESS = "MARK_DELIVERED_ORDER_SUCCESS";
export const MARK_DELIVERED_ORDER_FAIL = "MARK_DELIVERED_ORDER_FAIL";

export const GET_ORDER_DELIVERED_REQUEST = "GET_ORDER_DELIVERED_REQUEST";
export const GET_ORDER_DELIVERED_SUCCESS = "GET_ORDER_DELIVERED_SUCCESS";
export const GET_ORDER_DELIVERED_FAIL = "GET_ORDER_DELIVERED_FAIL";

export const SAVE_PICKUP_INFO = "SAVE_PICKUP_INFO";
export const SAVE_PICKUP_INFO_ERROR = "SAVE_PICKUP_INFO_ERROR";

export const SAVE_DROPOFF_INFO = "SAVE_DROPOFF_INFO";
export const SAVE_DROPOFF_INFO_ERROR = "SAVE_DROPOFF_INFO_ERROR";

export const SAVE_LENGTH = "SAVE_LENGTH";
export const SAVE_HEIGTH = "SAVE_HEIGTH";
export const SAVE_WIDTH = "SAVE_WIDTH";
export const SAVE_LHW_ERROR = "SAVE_LHW_ERROR";

export const SAVE_COURIER_INFO = "SAVE_COURIER_INFO";
export const SAVE_COURIER_INFO_ERROR = "SAVE_COURIER_INFO_ERROR";

export const SAVE_PAYMENT_INFO = "SAVE_PAYMENT_INFO";
export const SAVE_PAYMENT_INFO_ERROR = "SAVE_PAYMENT_INFO_ERROR";

export const PLACE_ORDER_REQUEST = "PLACE_ORDER_REQUEST";
export const PLACE_ORDER_SUCCESS = "PLACE_ORDER_SUCCESS";
export const PLACE_ORDER_FAIL = "PLACE_ORDER_FAIL";

export const GET_LAT_LONG = "GET_LAT_LONG";
export const GET_LAT_LONG_ERROR = "GET_LAT_LONG_ERROR";

export const GET_DIRECTION_REQUEST = "GET_DIRECTION_REQUEST";
export const GET_DIRECTION = "GET_DIRECTION";
export const GET_DIRECTION_ERROR = "GET_DIRECTION_ERROR";
